export default {
  init() {
    // JavaScript to be fired on the home page
    showAndHideVideo();
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};

function showAndHideVideo() {
  const closeVideoIframeButton = document.getElementById(
    "closeVideoIframeButton"
  );
  const videoIframeDiv = document.getElementById("videoIframeDiv");
  const videoIframe = document.getElementById("videoIframe");
  const showVideoIframeButton = document.getElementById(
    "showVideoIframeButton"
  );

  if (
    !videoIframe ||
    !videoIframeDiv ||
    !showVideoIframeButton ||
    !closeVideoIframeButton
  )
    return;

  // show video on show button click
  showVideoIframeButton.addEventListener("click", () => {
    _addClass(videoIframeDiv, "flex");
    _removeClass(videoIframeDiv, "hidden");
  });

  // close button on close button click
  closeVideoIframeButton.addEventListener("click", () => {
    videoIframe.src = videoIframe.src;
    _addClass(videoIframeDiv, "hidden");
    _removeClass(videoIframeDiv, "flex");
  });
}

function _removeClass(element, classname) {
  if (element.classList.contains(classname)) {
    element.classList.remove(classname);
  }
}

function _addClass(element, classname) {
  if (!element.classList.contains(classname)) {
    element.classList.add(classname);
  }
}



// WEBPACK FOOTER //
// ./scripts/routes/home.js